import { Typography } from '../../../summary/components/Typography.tsx';
import { isCosted } from '../AdjustmentBreakdown/isCosted.ts';
import { SummarySection } from '../SummarySection.tsx';
import { SummaryTableHorizontal } from '../SummaryTableHorizontal.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { BreakdownColumn, Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { adjustment } from '../utils/formatters/adjustment.ts';
import { calculations } from '../utils/formatters/calculations.ts';
import { getTableData } from '../utils/getTableData.ts';

const tableDef: BreakdownColumn[] = [
  {
    header: 'Feature',
    type: 'feature',
    adjustmentType: 'manual',
    path: 'text',
  },
  {
    header: 'Adjustment Calculation',
    type: 'adjustment',
    path: 'calculations',
    valueFormatter: calculations,
    adjustmentType: 'manual',
  },
  {
    header: 'Adjustment',
    type: 'adjustment',
    path: 'adjustment',
    adjustmentType: 'manual',
    valueFormatter: adjustment,
    textAlign: 'right',
  },
];

export const AdjustmentBreakdownDepreciatedCostAdditionalImprovementsManual = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => {
  if (!isCosted(props.results, 'manual')) {
    return null;
  }

  const tableData = getTableData(tableDef, props, props.compSequence);
  const title = props.results.adjustmentLabels.manual;

  return (
    <SummarySection marginBottom="2rem">
      <TitleAndExportToggleLockup
        {...props}
        title={title}
        id="isDepreciatedCostAdditionalImprovementsManualInExport"
        variant="h3"
      />
      <Typography variant="body1">
        {`The ${title} adjustment is based on the difference between the comparable’s ${title} value
                and the subject’s ${title} value. Value was estimated by the appraiser.`}
      </Typography>
      <SummaryTableHorizontal
        {...props}
        summary={props}
        compSequence={props.compSequence}
        columns={tableDef}
        tableData={tableData}
        subjectHeader="SUB"
        compHeaderPrefix="CP"
      />
    </SummarySection>
  );
};
